var _rect, _rect2, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -3.22635,
    y: -3.22635,
    width: 38.4527,
    height: 38.4527
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.61px)",
      clipPath: "url(#bgblur_0_1248_728_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 3.22635,
    width: 32,
    height: 32,
    rx: 6.4,
    fill: "white",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.16724,
    y: 5.98828,
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 12.75L19.4402 17.7625C19.361 19.0432 19.3214 19.6836 19.0004 20.144C18.8416 20.3716 18.6373 20.5637 18.4003 20.708C17.921 21 17.2795 21 15.9963 21C14.7116 21 14.0691 21 13.5895 20.7074C13.3524 20.5628 13.148 20.3704 12.9893 20.1424C12.6684 19.6813 12.6297 19.04 12.5523 17.7576L12.25 12.75",
    stroke: "#FF4D40",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.75H20.5M18.0279 12.75L17.6866 12.0459C17.4598 11.5781 17.3464 11.3443 17.1508 11.1984C17.1075 11.1661 17.0616 11.1373 17.0135 11.1124C16.797 11 16.5371 11 16.0173 11C15.4844 11 15.218 11 14.9978 11.1171C14.949 11.143 14.9025 11.173 14.8586 11.2066C14.6608 11.3584 14.5503 11.6008 14.3293 12.0856L14.0265 12.75",
    stroke: "#FF4D40",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 18.25V15.25",
    stroke: "#FF4D40",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 18.25V15.25",
    stroke: "#FF4D40",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1248_728_clip_path",
    transform: "translate(3.22635 3.22635)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5163ba234277ea3d189f619616ed786a.svg";
export { ForwardRef as ReactComponent };